import $ from 'jquery';
import WindowResize from './Window/_WindowResize.js';
import Scroll from './Window/_Scroll.js';
import Op from './Op/_OpAnim.js';
import End from './End/_EndAnim';
import { ManagePage } from './Manage/_ManagePage.js';

(() => {
  $(window).on('load', function () {
    ManagePage.init();
    new Op();
    new WindowResize();
    new Scroll();
    new End();
  });
})();
